var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcContent,{attrs:{"app-name":"files"}},[(!_setup.isPublic)?_c(_setup.FilesNavigation):_vm._e(),_vm._v(" "),_c(_setup.FilesList,{attrs:{"is-public":_setup.isPublic}}),_vm._v(" "),(!_setup.isPublic)?_c(_setup.FilesSidebar):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }